/* eslint-disable jsx-a11y/no-onchange */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

export default function CustomNativeSelect({
  ariaLabel,
  children,
  className,
  disabled,
  id,
  isLarge,
  onChange,
  tall,
  testId,
  value,
}) {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div
        className={classNames(
          'custom-select',
          { 'custom-select--disabled': disabled },
          className,
        )}
      >
        <select
          aria-label={ariaLabel}
          className="custom-select__select"
          data-testid={testId}
          disabled={disabled}
          id={id}
          onChange={onChange}
          value={value}
        >
          {children}
        </select>
      </div>
      <style jsx>{`
        .custom-select {
          position: relative;
          display: inline-block;
          height: ${isLarge ? '38px' : '28px'};
          line-height: 1em;
        }
        @media (max-width: ${theme.breakpoints.smDown}) {
          .custom-select {
            height: ${tall ? '38px' : '28px'};
          }
        }
        .custom-select:after {
          content: '';
          pointer-events: none;
          position: absolute;
          top: calc(50% - 2px);
          right: 8px;
          width: 0;
          height: 0;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-top: 5px solid #333333;
        }
        .custom-select__select {
          background-color: transparent;
          color: #333333;
          font-size: ${isLarge ? '16px' : '14px'};
          min-width: 50px;
          height: ${isLarge ? '38px' : '28px'};
          border: 1px solid #b3b3b3;
          border-radius: 5px;
          padding: 0 23px 0 8px;
          appearance: none;
          line-height: ${isLarge ? '1.4em' : '1.2em'};
        }
        @media (max-width: ${theme.breakpoints.smDown}) {
          .custom-select__select {
            height: ${tall ? '38px' : '28px'};
          }
        }
        .custom-select__select::-ms-expand {
          display: none;
        }
        .custom-select.primary .custom-select__select {
          color: ${theme.colors.primary};
          border: 1px solid ${theme.colors.primary};
          background-color: #ffffff;
        }
        .custom-select.primary:after {
          border-top: 5px solid ${theme.colors.primary};
        }
        .custom-select.bg-white .custom-select__select {
          background-color: #ffffff;
        }
        .custom-select.full-width,
        .custom-select.full-width .custom-select__select {
          width: 100%;
        }
        .custom-select.margin {
          margin-bottom: 8px;
        }
        .custom-select--disabled:after {
          border-top: 5px solid #cccccc;
        }
      `}</style>
    </>
  );
}

CustomNativeSelect.propTypes = {
  ariaLabel: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  isLarge: PropTypes.bool,
  onChange: PropTypes.func,
  tall: PropTypes.bool,
  testId: PropTypes.string,
  value: PropTypes.any,
};
